import React from 'react';
import { Route } from 'react-router-dom'
import HeartRunnerProfileComponent from '../../HeartRunnerManagement/containers/heartRunnerProfileContainer';


export const HeartRunnerRouteComponent = () => (
    <div>
        <Route exact path="/HeartRunner/Profile" component={HeartRunnerProfileComponent} />
    </div>

)
